import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IndicatorBoxModel } from '../../../../models/indicator-box.model';
import { IndicatorsSearchToolbarModel } from '../../../../models/indicators-search-toolbar-model.model';
import { LoyaltyChart } from '../../../../models/loyalty-chart-config.model';
import { QFilterModel } from '../../../../models/qfilter.model';
import { NumberKMPipe } from '../../../../pipes/numberKMPipe';
import { AnalyticsService } from '../../../../services/analytics/analytics.service';
import { CustomerCampaignService } from '../../../../services/customer/customer-campaign.service';
import { IndicatorsChartService, IndicatorsService } from '../../../../services/indicators/indicators.service';
import { SearchToolbarModelFactoryService } from '../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';


// Pagina 9
@Component({
  selector: 'app-contactable-main-kpi',
  templateUrl: './contactable-main-kpi.component.html',
  styleUrls: ['./contactable-main-kpi.component.css']
})
export class ContactableMainKpiComponent implements OnInit {
  show_results = false;

  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  public indicators: IndicatorBoxModel[] = [];
  public translations: any;
  public storeError = false;
  public selectOneError: string;
  public data: QFilterModel;
  public segmentContactabilityChart: LoyaltyChart;
  public waterfallContactabilityChart: LoyaltyChart;

  constructor(
    private indicatorService: IndicatorsService,
    private chartsService: IndicatorsChartService,
    private svcAnalytics: AnalyticsService,
    private srvCustomerCampaign: CustomerCampaignService,
    private translate: TranslateService,
    private searchModelFactory: SearchToolbarModelFactoryService,
  ) {
    this.translate.get([
      'kpiChart.segmentDistribution',
      'kpiChart.selectedShop',
      'kpiChart.formatAverage',
      'kpiChart.axisTitle',
      'contactable.FunnelMarketing11',
      'contactable.ContactabilityForValue'
    ]).subscribe((t) => {
      this.translations = {
        segmentDistribution: t['kpiChart.segmentDistribution'],
        selectedShop: t['kpiChart.selectedShop'],
        formatAverage: t['kpiChart.formatAverage'],
        axisTitle: t['kpiChart.axisTitle'],
        FunnelMarketing11: t['contactable.FunnelMarketing11'],
        ContactabilityForValue: t['contactable.ContactabilityForValue']
      };
    });

    this.translate.get('store.selectOneErrorMsg').subscribe(msg => { this.selectOneError = msg; });

    this.initChart();
  }

  ngOnInit() {

  }

  initChart() {
    this.waterfallContactabilityChart = new LoyaltyChart('waterfall');
    this.waterfallContactabilityChart.options.xAxis = {type: 'category'};
    this.waterfallContactabilityChart.options.legend = {verticalAlign: 'bottom'};
    this.waterfallContactabilityChart.options.legend.enabled = false;
    this.waterfallContactabilityChart.options.tooltip = {
      formatter: function() {
        return NumberKMPipe.formatDynamic(this.y);
      }
    };

    this.segmentContactabilityChart = new LoyaltyChart('bar');
    this.segmentContactabilityChart.options.xAxis = {type: 'category'};
    this.segmentContactabilityChart.options.legend = {verticalAlign: 'bottom'};
    this.segmentContactabilityChart.options.legend.enabled = false;
    this.segmentContactabilityChart.options.tooltip = {
      formatter: function() {
        return NumberKMPipe.formatDynamic(this.y);
      }
    };
  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }

  searchValue(data: QFilterModel) {
    this.data = data;

    this.indicators = [];

    this.indicatorService.indicatorCalculation('Q037', this.data).subscribe(Q037 => {

      /*Q037*/
      this.indicators.push(new IndicatorBoxModel([Q037.find(r => r.name === 'iscritti_loyalty')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2}));
      /*Q037*/
      this.indicators.push(new IndicatorBoxModel([Q037.find(r => r.name === 'raggiungibilita_clienti')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}));
      /*Q037*/
      this.indicators.push(new IndicatorBoxModel([Q037.find(r => r.name === 'clienti_profilabili')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}));
      /*Q037*/
      this.indicators.push(new IndicatorBoxModel([Q037.find(r => r.name === 'clienti_target')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '%'}));
    });

    this.segmentChartInit (data);
    this.waterfallChartInit (data);

    this.show_results = true;

  }

  waterfallChartInit (data) {
    this.indicatorService.getChart('customers.Q127', data, false).subscribe( res => {


      let serie0 = res.series[0].serie;
      let serie1 = res.series[1].serie;
      let series: Array<any> = [];

      for (let i = 0; i < serie0.length; i++) {
        let y = serie1[i];
        if (i === serie0.length - 1) {
          y = -1 * y;
        }
        series.push ( {name: serie0[i], y: y} );

      }

      if (this.waterfallContactabilityChart.instance) {
        while (this.waterfallContactabilityChart.instance.series.length > 0) {
          this.waterfallContactabilityChart.instance.series[0].remove(true);
        }
      }

      this.waterfallContactabilityChart.options.series = [{ name: this.translations.waterfallContactabilityChart, colorByPoint: true, data: series }];
      this.waterfallContactabilityChart.instance.addSeries(series);

      this.waterfallContactabilityChart.instance.update(this.waterfallContactabilityChart.options);

      this.waterfallContactabilityChart.instance.redraw();

    });
  }
  segmentChartInit (data) {
    this.indicatorService.getChart('customers.Q128', data, false).subscribe(res => {

      let serie0 = res.series[0].serie;
      let serie1 = res.series[1].serie;
      let colori = res.series[3].serie;
      let series: Array<any> = [];

      for (let i = 0; i < serie0.length; i++) {
        series.push ( {name: serie0[i], y: serie1[i], color: colori[i]} );
      }

      if (this.segmentContactabilityChart.instance) {
        while (this.segmentContactabilityChart.instance.series.length > 0) {
          this.segmentContactabilityChart.instance.series[0].remove(true);
        }
      }


      this.segmentContactabilityChart.options.series = [{ name: this.translations.segmentsInvoiceTitle, colorByPoint: true, data: series }];
      this.segmentContactabilityChart.instance.addSeries(series);

      this.segmentContactabilityChart.instance.update(this.segmentContactabilityChart.options);
      this.segmentContactabilityChart.instance.redraw();

    });
  }

  public toogleErrorStoreDialog() {
    this.storeError = !this.storeError;
  }

  resetData() {
    this.show_results = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers-contactable/contactable-main-kpi/contactable-main-kpi.component.ts